import type { InputProps } from '@lokalise/louis';
import { Input, useMergeRefs } from '@lokalise/louis';
import { useField } from 'formik';
import { forwardRef, useRef } from 'react';

import useEffectOnce from '@app/hooks/useEffectOnce';

interface InputFieldProps extends Omit<InputProps, 'error'> {
    name: string;
}

const InputField = forwardRef<HTMLInputElement, InputFieldProps>(({ name, ...props }: InputFieldProps, ref) => {
    const [field, { touched, error }] = useField({ name, type: props.type ?? 'text', disabled: props.disabled });

    const innerRef = useRef<HTMLInputElement>(null);
    const mergedRef = useMergeRefs(ref, innerRef);

    useEffectOnce(() => {
        if (props.autoFocus && innerRef.current) {
            innerRef.current.autofocus = true;
        }
    });

    return <Input ref={mergedRef} {...field} error={touched ? error : undefined} {...props} />;
});

InputField.displayName = 'InputField';

export default InputField;
